import { render, staticRenderFns } from "./badData.vue?vue&type=template&id=52398aed&scoped=true&"
import script from "./badData.vue?vue&type=script&lang=js&"
export * from "./badData.vue?vue&type=script&lang=js&"
import style0 from "./badData.vue?vue&type=style&index=0&id=52398aed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52398aed",
  null
  
)

export default component.exports